import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";

const projects = [
    {
        title: "Railway Platform Construction",
        meta: "Station civil works",
        location: "Jodhpur Division",
        img: "https://images.unsplash.com/photo-1623002891503-fd1274ea9800?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        tall: false,
    },
    {
        title: "Track Laying & Linking Works",
        meta: "Railway track execution",
        location: "Rajasthan Sector",
        img: "https://images.unsplash.com/photo-1574757987642-5755f0839101?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        tall: true,
    },
    {
        title: "Metro & Rail Corridor Works",
        meta: "Urban rail infrastructure",
        location: "Urban Corridor",
        img: "https://images.unsplash.com/photo-1560521608-b4e1acca0824?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        tall: false,
    },
    {
        title: "Concrete & Bridge Structures",
        meta: "RUB / ROB structural works",
        location: "Rajasthan Sector",
        img: "https://images.unsplash.com/photo-1569258592171-357ea26da4df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
        tall: true,
    },
];

export default function Projects() {
    return (
        <section id="projects" data-testid="projects-section" className="border-b border-navy-line">
            <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32">
                <div className="mb-6">
                    <Reveal>
                        <Eyebrow>Selected Work</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="mt-6 font-display text-5xl font-semibold uppercase leading-[0.95] tracking-mega text-navy md:text-6xl">
                            Projects
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <p className="mb-14 max-w-lg text-sm leading-relaxed text-ink/50">
                        Representative sample projects shown for portfolio purposes — replace with
                        our executed project references on request.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    {projects.map((p, i) => (
                        <Reveal key={p.title} delay={(i % 2) * 0.08} className={p.tall ? "md:mt-16" : ""}>
                            <article
                                data-testid={`project-card-${i}`}
                                className="group cursor-pointer border border-navy-line bg-white transition-colors duration-300 hover:border-navy"
                            >
                                <div className="clip-tag relative h-72 overflow-hidden md:h-80">
                                    <img
                                        src={p.img}
                                        alt={p.title}
                                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                    />
                                    <div className="absolute inset-0 bg-navy/0 transition-colors duration-500 group-hover:bg-navy/20" />
                                    <div className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center border border-white/40 bg-paper/90 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                                        <ArrowUpRight className="h-5 w-5 text-navy" />
                                    </div>
                                </div>
                                <div className="flex items-start justify-between gap-4 p-6">
                                    <div>
                                        <h3 className="font-display text-xl font-semibold uppercase tracking-[0.02em] text-navy">
                                            {p.title}
                                        </h3>
                                        <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide2 text-ink/45">
                                            {p.meta}
                                        </p>
                                    </div>
                                    <div className="flex shrink-0 items-center gap-1.5 text-ink/50">
                                        <MapPin className="h-3.5 w-3.5" />
                                        <span className="text-xs font-medium">{p.location}</span>
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
